import { Controller } from "@hotwired/stimulus";
import { Toast } from "bootstrap";

export default class extends Controller {
  static targets = ["toast"];

  close(event) {
    const element = event.currentTarget.closest('[data-toast-target="toast"]');
    if (element) {
      Toast.getInstance(element)?.hide();
      element.remove();
    }
  }

  toastTargetConnected(element) {
    Toast.getOrCreateInstance(element, {
      autohide: true,
      delay: 5000,
      animation: true,
    }).show();

    element.addEventListener("hidden.bs.toast", (event) => {
      event.currentTarget.removeEventListener("hidden.bs.toast", this);
      event.currentTarget.remove();
    });
  }
}
